import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ModuleWithProviders } from "@angular/core";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { HttpClient } from "@angular/common/http";

import { MatMomentDateModule } from "@angular/material-moment-adapter";
import {
  DateAdapter,
  MatDialogModule,
  MAT_DATE_LOCALE,
} from "@angular/material";
import { MomentDateAdapter } from "@angular/material-moment-adapter";
import { LOCALE_ID } from "@angular/core";

import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { HttpErrorInterceptorService } from "./http/http-error-interceptor.service";
import { NgxWebstorageModule } from "ngx-webstorage";
import { LangInterceptorService } from "./http/lang-interceptor.service";
import { DialogUtilsComponent } from "./dialog-utils/dialog-utils.component";

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

@NgModule({
  declarations: [DialogUtilsComponent],
  imports: [
    CommonModule,
    HttpClientModule,
    MatMomentDateModule,
    MatDialogModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
      isolate: false,
    }),
    NgxWebstorageModule.forRoot({
      prefix: "tramitador-frontend-jwt",
      separator: "-",
    }),
  ],
  exports: [TranslateModule],
  entryComponents: [DialogUtilsComponent],
})
export class CoreModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: CoreModule,
      providers: [
        {
          provide: DateAdapter,
          useClass: MomentDateAdapter,
          deps: [MAT_DATE_LOCALE],
        },
        { provide: LOCALE_ID, useValue: "es" },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: HttpErrorInterceptorService,
          multi: true,
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: LangInterceptorService,
          multi: true,
        },
      ],
    };
  }
}
